<script setup lang="ts">
import type { AcceptableValue } from 'reka-ui'

const time = defineModel<string>({ required: true })

withDefaults(
  defineProps<{
    disabled?: boolean
  }>(),
  { disabled: false }
)

const toTwoDigits = (value: number) => String(value).padStart(2, '0')

const hourOptions = Array.from({ length: 24 }, (_, index) => toTwoDigits(index))
const minuteOptions = Array.from({ length: 60 }, (_, index) => toTwoDigits(index))

const hour = computed(() => (time.value ? time.value.split(':')[0] : undefined))
const minute = computed(() => (time.value ? time.value.split(':')[1] : undefined))

const setHour = (value: AcceptableValue) => {
  time.value = `${String(value)}:${minute.value ?? '00'}`
}

const setMinute = (value: AcceptableValue) => {
  time.value = `${hour.value ?? '00'}:${String(value)}`
}
</script>

<template>
  <div class="flex w-full gap-1">
    <Select :model-value="hour" :disabled="disabled" @update:model-value="setHour">
      <SelectTrigger class="flex-1">
        <SelectValue placeholder="--" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem v-for="option in hourOptions" :key="option" :value="option">
          {{ option }}
        </SelectItem>
      </SelectContent>
    </Select>
    <Select :model-value="minute" :disabled="disabled" @update:model-value="setMinute">
      <SelectTrigger class="flex-1">
        <SelectValue placeholder="--" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem v-for="option in minuteOptions" :key="option" :value="option">
          {{ option }}
        </SelectItem>
      </SelectContent>
    </Select>
  </div>
</template>
